// Centralized constants for demo data consistency across FarmTrace and Solar

export const DEMO_CONSTANTS = {
    // General Farm Stats
    FARM_NAME: "Hacienda La Esperanza",
    TOTAL_COWS: 150,
    ACTIVE_COWS: 128,

    // Production Stats
    DAILY_MILK_PRODUCTION: 3850, // Liters per day
    AVG_MILK_PER_COW: 30.1, // Liters

    // Energy Stats (Solar & Consumption)
    SOLAR_SYSTEM_SIZE: 50, // kWp
    DAILY_SOLAR_GENERATION: 220, // kWh (Average)
    DAILY_TOTAL_CONSUMPTION: 480, // kWh
    GRID_CONSUMPTION: 260, // kWh (Total - Solar)
    SOLAR_COVERAGE_PERCENTAGE: 45.8, // (Solar / Total) * 100

    // Efficiency Metrics
    ENERGY_PER_LITER: 0.125, // kWh per Liter (Total Consumption / Production)
    SOLAR_ENERGY_PER_LITER: 0.057, // kWh Solar per Liter

    // Financials
    ENERGY_COST_GRID: 0.15, // USD/kWh
    ENERGY_COST_SOLAR: 0.00, // USD/kWh (marginal cost)
    MILK_PRICE: 0.38, // USD/Liter

    // Environmental
    CO2_FACTOR_GRID: 0.4, // kg CO2 per kWh
    CO2_SAVINGS_PER_KWH: 0.4, // kg CO2 saved per solar kWh
};

// Derived calculations for consistency
export const calculateDailyEnergyCost = () => {
    return (DEMO_CONSTANTS.GRID_CONSUMPTION * DEMO_CONSTANTS.ENERGY_COST_GRID);
};

export const calculateEnergyCostPerLiter = () => {
    return calculateDailyEnergyCost() / DEMO_CONSTANTS.DAILY_MILK_PRODUCTION;
};

export const calculateMonthlyCO2Savings = () => {
    return (DEMO_CONSTANTS.DAILY_SOLAR_GENERATION * DEMO_CONSTANTS.CO2_SAVINGS_PER_KWH * 30) / 1000; // Tons
};
